/* MECHONCITO — Reveal al entrar en pantalla
   Etiqueta el contenido desde JS para no tener que tocar product.json.

   Dos reglas de oro:
   1. Si algo falla, el contenido se muestra igual. Nunca puede quedar
      invisible por culpa de una animacion.
   2. No medimos posiciones a mano. En DOMContentLoaded las imagenes todavia
      no tienen alto y TODO el documento esta colapsado cerca del top, asi
      que cualquier medicion propia da falsos positivos. El
      IntersectionObserver reevalua solo cuando el layout cambia. */
(function () {
  'use strict';

  var raiz = document.documentElement;
  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducido || !('IntersectionObserver' in window)) return;

  /* Secciones que NO se animan: el header, el footer, la ficha de producto
     (el cliente llega y tiene que ver el precio de inmediato) y las resenas. */
  var EXCLUIR = /__header|__footer|__main$|17861517402065fa26/;

  function bloqueDe(seccion) {
    return seccion.querySelector('.page-width')
        || seccion.querySelector('.isolate')
        || seccion.firstElementChild;
  }

  function marcar(seccion) {
    if (EXCLUIR.test(seccion.id)) return [];
    var marcados = [];

    /* Una grilla de 2 a 8 hijos entra escalonada */
    var grilla = seccion.querySelector('.multicolumn-list, .multirow__inner');
    if (grilla && grilla.children.length > 1 && grilla.children.length <= 8) {
      grilla.setAttribute('data-mch-reveal', 'stagger');
      marcados.push(grilla);
    }

    /* El bloque de contenido entra completo, si no contiene ya la grilla */
    var bloque = bloqueDe(seccion);
    if (bloque && bloque.offsetHeight > 60 && !(grilla && bloque.contains(grilla))) {
      bloque.setAttribute('data-mch-reveal', 'basic');
      marcados.push(bloque);
    }

    return marcados;
  }

  var observador = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-visible');
      observador.unobserve(e.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function mostrarTodo() {
    var todos = document.querySelectorAll('[data-mch-reveal]');
    for (var i = 0; i < todos.length; i++) todos[i].classList.add('is-visible');
  }

  function iniciar() {
    var secciones = document.querySelectorAll('.shopify-section');
    var total = 0;

    for (var i = 0; i < secciones.length; i++) {
      var marcados = marcar(secciones[i]);
      for (var j = 0; j < marcados.length; j++) {
        /* Sin medir nada: el observador decide. Lo que ya esta en pantalla
           recibe is-visible en su primer callback, casi de inmediato. */
        observador.observe(marcados[j]);
        total++;
      }
    }

    if (total) raiz.classList.add('mch-reveal-on');

    /* Red de seguridad: 3 s despues de que cargue todo, nada queda oculto */
    if (document.readyState === 'complete') {
      setTimeout(mostrarTodo, 3000);
    } else {
      window.addEventListener('load', function () { setTimeout(mostrarTodo, 3000); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  /* Al editar en el theme editor la seccion se vuelve a montar */
  document.addEventListener('shopify:section:load', function (e) {
    var marcados = marcar(e.target);
    for (var i = 0; i < marcados.length; i++) marcados[i].classList.add('is-visible');
  });
})();
